var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6566 10.447C33.2727 11.0512 33.2823 12.0405 32.678 12.6566L16.7405 28.9066C16.4485 29.2043 16.0496 29.373 15.6326 29.375C15.2156 29.377 14.815 29.2122 14.5201 28.9174L6.70765 21.1049C6.09745 20.4947 6.09745 19.5053 6.70765 18.8951C7.31784 18.285 8.30716 18.285 8.91735 18.8951L15.6142 25.592L30.447 10.4684C31.0512 9.85234 32.0405 9.84273 32.6566 10.447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.a2411eb1431067184a0bc7d8ce1366d5.svg";
export { ForwardRef as ReactComponent };